module.exports = [
	{
		"start": 0.13,
		"text": "I came here when I was 2 years old, in 1991. We came here on tourist visas. We overstayed our visas, yes."
	},
	{
		"start": 7.06,
		"text": "I remember that we had this house in San Antonio, and in the front yard we had a pecan tree."
	},
	{
		"start": 11.769,
		"text": "I think I was about 3 or 4 years old, and I just remember my grandmother and I would go out into the front yard and get the pecans off the ground."
	},
	{
		"start": 19.519,
		"text": "At the end of middle school, early on in high school, I started to travel with the high school marching band, and my mom would get nervous."
	},
	{
		"start": 26.849,
		"text": "I didn't understand why until there was a moment where she did tell me, you know,"
	},
	{
		"start": 31.4,
		"text": "“No tienes papeles.\" \"You don't have any papers.\""
	},
	{
		"start": 34.54,
		"text": "I had already been able to go to university because in the state of Texas you can get"
	},
	{
		"start": 39.79,
		"text": "in-state tuition if you're undocumented, but I knew I wasn't gonna be able to do anything with my degree."
	},
	{
		"start": 45.93,
		"text": "So I was driving home, from I think picking up a textbook or something, and my mom calls"
	},
	{
		"start": 49.68,
		"text": "me, and she said, \"Are you driving?\" And I told her “yeah,” and she's like, “Pull over now.\""
	},
	{
		"start": 53.16,
		"text": "And she said, \"President Obama just announced DACA, I already got you a lawyer.\""
	},
	{
		"start": 57.89,
		"text": "We were both just crying on the phone because it would mean all my hard work"
	},
	{
		"start": 64.269,
		"text": "in college, and now going through a master's program, could potentially lead to me being able to work."
	},
	{
		"start": 69.999,
		"text": "So it was just one of the best days of my life, honestly."
	},
	{
		"start": 73.82,
		"text": "Fast forward five years and we were told that DACA was being rescinded, and I'm outside of the window to renew."
	},
	{
		"start": 83.16,
		"text": "So I've kind of just been, you know, preparing myself mentally that this could be my last year teaching."
	},
	{
		"start": 91.16,
		"text": "And I do feel a little bit of fear. I'm anxious, a little sad, a little bit betrayed."
	},
	{
		"start": 97.46,
		"text": "You know, I pay my taxes. I work hard. I'm educating kids."
	},
	{
		"start": 102.069,
		"text": "I pledge allegiance to the same flag every day at school. I stand up for the national anthem, you know."
	},
	{
		"start": 108.28,
		"text": "I should have opportunities because I grew up here. I'm an American, no matter what."
	},
	{
		"start": 114.18,
		"text": "I might not have papers, but I'm an American. So I'm here to stay."
	},
	{
		"start": 119.72,
		"text": "And I'm going to fight every step of the way."
	}
];


//////////////////
// WEBPACK FOOTER
// ../assets/transcripts/karen.json
// module id = 9
// module chunks = 0